/**
 * ppt
 */
 import Storage from 'store2'               //  本地存储

 const storagePptKey = 'pptData';					//	本地缓存key
 let storagePptData = Storage.get(storagePptKey); 	//	从缓存中获得数据
 
 //	数据内容
 let state = {
	 pptData: storagePptData ? storagePptData : {}, //	Ppt信息
 }
 
 //	同步
 const mutations = {
	 setPptDataSync(state, pptData) {
		 //	赋值Ppt信息
		 Storage.set(storagePptKey, pptData); //	将数据保存到缓存中
		 state.pptData = pptData;
	 },
 
 }
 
 //	异步，外部保存数据调用此内部方法
 const actions = {
	 setPptData({
		 commit
	 }, pptData) {
		 //	赋值Ppt信息
		 commit("setPptDataSync", pptData);
	 },
 }
 
 //	获取
 const getters = {
	 getPptData(state) {
		 //	获取Ppt信息
		 return state.pptData;
	 }
 }
 
 export default {
	 namespaced: true,
	 state,
	 getters,
	 actions,
	 mutations
 }
 